// extracted by mini-css-extract-plugin
export default {"tagListLetterHeader":"TagListItemsHeader_tagListLetterHeader__H10Ri"};